import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

export const registerPushAndVoip = async () => {
    try {
        if (Capacitor.getPlatform() === 'android') {
            console.log('🔨 Forcing Notification Channel Creation...');
            try {
                await PushNotifications.deleteChannel({ id: 'calls' });
            } catch (e) { /* channel might not exist */ }

            await PushNotifications.createChannel({
                id: 'calls',
                name: 'Consultation Calls',
                description: 'Notifications for incoming video/audio calls',
                sound: 'crystalline_dawn', // Links to res/raw/crystalline_dawn.mp3
                importance: 5, // IMPORTANCE_HIGH (Heads up)
                visibility: 1, // VISIBILITY_PUBLIC
                vibration: true
            });
            console.log('✅ Notification Channel "calls" established');
        }
        console.log('📡 Registering with FCM/APNS for standard Push...');
        await PushNotifications.register();
    } catch (e) {
        console.error('Push notification registration error:', e);
    }
};

export const initPushNotifications = async () => {
    if (Capacitor.getPlatform() === 'web') {
        console.log('Push Notifications skipped on Web');
        return;
    }

    try {
        const pStatus = await PushNotifications.checkPermissions();
        if (pStatus.receive === 'granted') {
            // Already granted previously, register silently
            await registerPushAndVoip();
        } else {
            console.log('Push permissions not yet granted. Waiting for PermissionGate to request.');
        }
    } catch (e) {
        console.error('Push notification initialization error:', e);
    }
};

export const addPushListeners = () => {
    if (Capacitor.getPlatform() === 'web') return;

    PushNotifications.addListener('registration', (token) => {
        console.log('Push Registration Token:', token.value);
        // Store locally so it can be sent instantly upon login
        localStorage.setItem('fcm_token', token.value);
        
        // Also try to send immediately if user is already logged in
        import('./api').then(({ authAPI }) => {
            authAPI.saveDeviceToken(token.value).catch(err => console.log('Token API skipped or failed (might not be logged in yet)'));
        });
    });

    PushNotifications.addListener('registrationError', (error) => {
        console.error('Push Registration Error:', error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('Push Notification Received:', notification);

        // Handle incoming call even in background
        if (notification.data && notification.data.type === 'call_incoming') {
            console.log('📞 Incoming call data received via Push');
            // Dispatch event to show overlay and play sound
            const event = new CustomEvent('push_call_incoming', { detail: notification.data });
            window.dispatchEvent(event);
        }
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        console.log('Push Notification Action Performed:', notification);

        if (notification.notification.data && notification.notification.data.type === 'call_incoming') {
            const consultationId = notification.notification.data.consultationId;
            if (consultationId) {
                // Store in localStorage so App.js can pick it up even if app was killed
                localStorage.setItem('pending_notif_consultation', consultationId);
                // Also attempt immediate navigation if app is already alive
                window.location.hash = `#/consultation/${consultationId}`;
            }
        }
    });

    // Native call handling is done via standard push notifications
    // iOS will use regular APNs push; Android uses FCM high-priority pushes
};
